"use client";

import { Phone, Mail, MapPin, ExternalLink } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function DaneKontaktoweIFormularz() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const contactDetails = [{
    icon: MapPin,
    label: "Adres",
    value: "ul. Adama Mickiewicza 57, 76-200 Słupsk",
    link: "https://maps.app.goo.gl/r55ANnzsmRLWb2Gi6?g_st=aw"
  }, {
    icon: Phone,
    label: "Telefon",
    value: "504 144 406",
    link: "tel:504144406"
  }, {
    icon: Mail,
    label: "Email",
    value: "b.parchomiuk@trasta.pl\n\n",
    link: "mailto:b.parchomiuk@trasta.pl"
  }];
  return <section id="dane-kontaktowe-i-formularz" className="bg-background text-foreground py-space-xl px-space-md overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={contentRef} className="transition-all duration-700 ease-[var(--ease-smooth)]" style={{
        opacity: contentVisible ? 1 : 0,
        transform: contentVisible ? "translateY(0)" : "translateY(30px)"
      }}>
          <div className="grid grid-cols-1 gap-space-xl items-start ![padding:0px_0px_7px_0px] lg:grid-cols-2">
            {}
            <div className="space-y-space-lg">
              <div className="space-y-space-md ![padding:0px_8px_0px_8px]">
                <h2 className="text-primary font-display font-semibold leading-tight !text-[26px]"><br />Masz pytania dotyczące swojej sprawy po wypadku?<br /><br /></h2>
                
                <div className="space-y-space-sm font-serif text-lg text-muted-foreground leading-relaxed max-w-xl">
                  <p className="!text-lg">Jeśli uczestniczyłeś w wypadku komunikacyjnym, otrzymałeś decyzję ubezpieczyciela albo nie masz pewności, czy przysługują Ci dalsze roszczenia, warto skonsultować swoją sytuację.<br /><br /></p>
                  <p className="!text-lg">Po zapoznaniu się z przedstawionymi informacjami oraz dokumentami możliwa jest wstępna ocena sprawy i wskazanie, jakie działania mogą być podjęte w związku z dochodzeniem świadczeń z polisy OC sprawcy.<br /><br /></p>
                  <p className="font-semibold text-foreground !text-xl !not-italic">Wstępna analiza sprawy jest bezpłatna.<br /><br /></p>
                  <p className="!text-lg">Na jej podstawie przekazywana jest informacja o możliwych dalszych krokach oraz o sposobie prowadzenia sprawy.<br /><br /></p>
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-space-md pt-space-md">
                {contactDetails.map((item, i) => <Link key={item.label} to={item.link} newTab={item.label === "Adres"} data-index={i} className="flex items-start gap-space-md p-space-md rounded-md hover:bg-primary-light transition-colors duration-200 group">
                    <div className="bg-primary/10 p-3 rounded-full group-hover:bg-primary group-hover:text-white transition-all duration-300">
                      <item.icon className="size-6 text-primary group-hover:text-white shrink-0" />
                    </div>
                    <div className="space-y-1">
                      <p className="font-sans font-semibold text-sm uppercase tracking-wider text-muted-foreground">
                        {item.label}
                      </p>
                      <p className="text-foreground text-lg font-medium leading-snug">
                        {item.value}
                      </p>
                    </div>
                  </Link>)}
              </div>
            </div>

            {}
            <div className="relative group lg:sticky lg:top-8">
              <div className="absolute -inset-4 bg-primary/5 rounded-xl -z-10 blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <Link to="https://maps.app.goo.gl/r55ANnzsmRLWb2Gi6?g_st=aw" newTab className="card block overflow-hidden border border-border hover-lift ring-1 ring-black/5">
                <div className="relative h-[450px] w-full ![margin:8px_0px_8px_0px]">
                  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2334.8!2d17.0286!3d54.4639!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTTCsDI3JzUwLjAiTiAxN8KwMDEnNDMuMCJF!5e0!3m2!1sen!2spl!4v1234567890" width="100%" height="100%" style={{
                  border: 0,
                  pointerEvents: "none"
                }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Lokalizacja Odszkodowania Słupsk" className="grayscale-[20%] group-hover:grayscale-0 transition-all duration-500"></iframe>
                  <div className="absolute bottom-4 right-4 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-md shadow-soft flex items-center gap-2 text-sm font-sans font-semibold text-primary">
                    <ExternalLink className="size-4" />
                    Otwórz w Mapach Google
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}